<template>
  <div>
    <Modal @closeModal="$emit('close-triggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <!-- <span class="font-weight-bold brand_navy">Add External Link</span> -->
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body" class="px-4">
        <div
          class="w-100"
          style="position: relative; top: -45px; margin-bottom: 15px"
        >
          <AuthAlertCard
            v-if="show_alert"
            :alert_type="alert_type"
            :alert_msg="alert_msg"
          ></AuthAlertCard>
        </div>

        <form
          action
          @submit.prevent="changeClass"
          autocomplete="off"
          style="margin-top: -20px"
        >
          <!-- CURRENT CLASS -->
          <div
            class="title brand_navy font-weight-800 font-20 text-center text-uppercase mb-4"
          >
            Change
            {{ getStudentName || "student" }}'s class
          </div>

          <div class="row">
            <div class="col-12 form-group-row">
              <label class="color_ash font-15">Current Class</label>
              <input
                type="text"
                class="form-control"
                :value="getClassName"
                disabled
              />
            </div>

            <!-- CLASS LIST -->
            <div class="col-12 form-group-row mt-3">
              <label class="color_ash font-15">New Class</label>
              <select v-model="new_class" class="form-control">
                <option value selected disabled>Select new class</option>
                <option
                  v-for="(item, index) in class_options"
                  :value="item.id"
                  :key="index"
                >
                  {{ item.class_name }}
                </option>
              </select>
            </div>
          </div>

          <!-- CANCEL OR SUBMIT FORM -->
          <div
            class="row d-flex justify-content-center align-items-center nowrap mt-4"
          >
            <button
              class="btn btn-md btn-grey-outline color_ash mr-3 font-12-5"
              @click="$emit('close-triggered')"
            >
              Cancel
            </button>
            <button
              class="btn btn-md btn-accent ml-3 font-12-5"
              ref="changeBtn"
            >
              Change class
            </button>
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Modal from "@/components/globalComps/Modal";
import { setTimeout } from "timers";

export default {
  name: "ChangeStudentClass",

  components: {
    Modal,
    AuthAlertCard: () =>
      import(
        /* webpackChunkName: "AuthAlertCard" */ "@/components/globalComps/AuthComps/AuthAlertCard.vue"
      ),
  },

  props: {
    student_data: Object,
  },

  computed: {
    ...mapGetters(["classList", "getCurrentClass"]),

    getStudentName() {
      if (this.account_type === "school") return this.student_data.full_name;
      else if (this.account_type === "teacher")
        return `${this.student_data.firstname} ${this.student_data.lastname}`;
      else return false;
    },

    getClassName() {
      return this.current_class_name;
    },
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
      show_alert: false,
      alert_type: null, //SET TO EITHER SUCCESS OR ERROR
      alert_msg: null,

      new_class: "",
      class_options: [],
      current_class_name: "Current class loading...",
    };
  },

  created() {
    this.getCurrentClassName();
    this.checkCLassListState();
  },

  methods: {
    ...mapActions([
      "updateStudentClass",
      "getSchoolClasses",
      "getTeacherSchoolClasses",
      "getSingleClass",
      "getClassDetailsByID",
    ]),

    // GET CURRENT CLASS NAME
    getCurrentClassName() {
      if (this.account_type === "school") {
        this.getSingleClass(this.getCurrentClass)
          .then(
            (response) => (this.current_class_name = response.data.class_name)
          )
          .catch((err) => console.log(err));
      } else {
        this.getClassDetailsByID(this.getCurrentClass)
          .then((response) => {
            this.current_class_name = response.data.data.class_name;
          })
          .catch((err) => console.log(err));
      }
    },

    checkCLassListState() {
      if (this.acccount_type === "school") {
        if (this.classList.length > 0) this.populateClassData(this.classList);
        else this.fetchSchoolClasses();
      } else this.fetchSchoolClasses();
    },

    fetchSchoolClasses() {
      if (this.account_type === "school") {
        this.getSchoolClasses()
          .then((response) => this.populateClassData(response.data))
          .catch((err) => console.log(err));
      } else {
        this.getTeacherSchoolClasses(this.getCurrentClass)
          .then((response) => this.populateClassData(response.data))
          .catch((err) => console.log(err));
      }
    },

    populateClassData(classData) {
      this.class_options = [];

      classData.map((class_level) => {
        class_level.classes.map((class_info) => {
          let class_obj = {};
          class_obj.id = Number(class_info.id);
          class_obj.class_name = class_info.class_name;
          class_obj.class_code = class_info.class_code;
          class_obj.active = false;

          this.class_options.push(class_obj);
        });
      });
    },

    changeClass() {
      this.$refs.changeBtn.disabled = true;
      this.$refs.changeBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Changing class...';

      this.updateStudentClass({
        account: this.account_type,
        student_id: this.student_data.id,
        class_id: this.new_class,
      })
        .then((response) => {
          if (response.code === 200) {
            setTimeout(() => {
              this.show_alert = false;

              this.$refs.changeBtn.disabled = true;
              this.$refs.changeBtn.innerHTML =
                '<div class="icon-accept font-18 mr-2"></div>Changed!';
            }, 1000);

            setTimeout(() => {
              let dialog_data = {
                msg: "Student class has been changed.",
                type: "success",
              };
              this.$emit("showAlertCard", dialog_data);
              this.$emit("close-triggered");
              this.$emit("update-student-class-list", this.student_data.index);

              // Message Parent here
            }, 3000);
          }

          // HANDLE NON 200 RESPONSE
          else {
            setTimeout(() => {
              this.show_alert = true;
              this.alert_type = "error";
              this.alert_msg = response.message;

              this.$refs.changeBtn.disabled = false;
              this.$refs.changeBtn.innerHTML = "Remove";
            }, 1000);

            setTimeout(() => {
              this.show_alert = false;
            }, 5000);
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss">
</style>